import React from "react";
import styles from "./FaqWidget.module.css";
import { Collapse, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";

const { Panel } = Collapse;

export const faqData = [
  {
    id: "faq-1",
    question: "How do I create an account?",
    answer:
      'Creating an account is simple! Click on the "Sign Up" button in the top right corner of our homepage. Fill in your personal details, create a password, and verify your email address. Once verified, you can log in and start using all our features.',
  },
  {
    id: "faq-2",
    question: "What payment methods do you accept?",
    answer:
      "We accept all major credit cards including Visa, MasterCard, American Express, and Discover. We also support PayPal, Apple Pay, and Google Pay. For business accounts, we can arrange direct bank transfers and invoice payments as well.",
  },
  {
    id: "faq-3",
    question: "How can I reset my password?",
    answer:
      'To reset your password, click on the "Login" button, then select "Forgot Password". Enter your email address, and we\'ll send you a password reset link. Click the link in the email and follow the instructions to create a new password.',
  },
  {
    id: "faq-4",
    question: "What is your refund policy?",
    answer:
      "We offer a 30-day money-back guarantee for all our subscription plans. If you're not satisfied with our service within the first 30 days, please contact our support team, and we'll process your refund. Please note that one-time purchases of digital goods are non-refundable after download.",
  },
  {
    id: "faq-5",
    question: "Do you offer a free trial?",
    answer:
      "Yes! We offer a 14-day free trial for all our premium plans. No credit card is required to start your trial. You'll get full access to all features during this period, and we'll send you a reminder before the trial ends.",
  },
  {
    id: "faq-6",
    question: "How can I contact customer support?",
    answer:
      'Our customer support team is available 24/7. You can reach us through the chat icon in the bottom right corner of our website, email us at support@example.com, or call us at 1-800-123-4567. For business inquiries, please use the contact form on our "Contact Us" page.',
  },
];

const FaqWidget = ({ data }) => {
  console.log("faq data 111", data);
  const width = useDeviceWidth();
  return (
    <div className={styles.faqWidgetDiv}>
      <div className={styles.contentDiv}>
        {data?.showTitle && (
          <div>
            <h1
              dangerouslySetInnerHTML={{ __html: data?.title }}
              data-aos="fade-up"
              data-aos-delay="150"
            ></h1>
          </div>
        )}
        {/* <h1>Frequently Asked Questions (FAQs)</h1> */}
        {/* <Collapse
          bordered
          defaultActiveKey={["1"]}
          expandIconPosition="end"
          //   expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          className={styles.collapse}
          items={faqData.map((faq) => ({
            key: faq.id,
            label: <span className={styles.question}>{faq.question}</span>,
            children: <div className={styles.answer}>{faq.answer}</div>,
          }))}
        /> */}
        <Collapse
          bordered
          defaultActiveKey={["1"]}
          expandIconPosition="end"
          expandIcon={({ isActive }) => (
            <DownOutlined
              rotate={isActive ? 180 : 0}
              style={{ fontSize: width > 1024 ? "15px" : "12px" }}
            />
          )}
          className={styles.collapse}
        >
          {data?.faq?.map((faq) => (
            <Panel
              header={faq.question}
              key={faq.id}
              className={styles.question}
            >
              <p className={styles.answer}>{faq.answer}</p>
            </Panel>
          ))}
        </Collapse>
      </div>
    </div>
  );
};

export default FaqWidget;
